<template>
  <div id="app" class="h-100" :class="[skinClasses]" v-if="loaded">
    <component :is="layout" >
      <router-view />
    </component>
  </div>
</template>

<script>
import { $themeColors, $themeBreakpoints, $themeConfig } from '@themeConfig'
import { useWindowSize, useCssVar } from '@vueuse/core'
import { provideToast } from 'vue-toastification/composition'
import { watch } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import store from '@/store'
import axios from '@axios'
import { getPublicSettings } from './composables/settingsService';

const LayoutVertical = () => import('@/layouts/vertical/LayoutVertical.vue')
const LayoutHorizontal = () => import('@/layouts/horizontal/LayoutHorizontal.vue')
const LayoutFull = () => import('@/layouts/full/LayoutFull.vue')

export default {
  components: {
    LayoutHorizontal,
    LayoutVertical,
    LayoutFull,
  },
  data() {
    return {
      loaded: false
    }
  },
  created () {
    if(localStorage.getItem('userData')){
    axios
      .post('refresh-data')
      .then(response => {
          localStorage.removeItem('userData')
          localStorage.setItem('userData', JSON.stringify(response.data))
          this.loaded = true
      }).catch(error => {
        localStorage.removeItem('userData')
        location.reload()
      })
    }else{
      this.loaded = true
    }

    if(localStorage.getItem('userData')){
      axios.get('modules').then((response) => {
        if(localStorage.getItem('modules')) localStorage.removeItem('modules')
        localStorage.setItem('modules', JSON.stringify(response.data))
      })
    }

  },
  computed: {
    layout() {
      if (this.$route.meta.layout === 'full') return 'layout-full'
      return `layout-${this.contentLayoutType}`
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type
    },
  },
  async beforeCreate() {
    const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark']

    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(`--${colors[i]}`, document.documentElement).value.trim()
    }

    const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl']
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(useCssVar(`--breakpoint-${breakpoints[i]}`, document.documentElement).value.slice(0, -2))
    }

    const { isRTL } = $themeConfig.layout
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr')

    // Aplicar configuraciones
    let settings = null
    settings = await getPublicSettings()
    if (settings.app_name) {
      $themeConfig.app.appName = settings.app_name
      document.title = settings.app_name
    }
    if (settings.favicon) {
      $themeConfig.app.appLogoImage = settings.favicon
    }
    if (settings.full_logo) {
      $themeConfig.app.appLogoLetraLight = settings.full_logo
      $themeConfig.app.appLogoLetraDark = settings.full_logo
    }
  },
  setup() {
    const { skin, skinClasses } = useAppConfig()

    if (skin.value === 'dark') document.body.classList.add('dark-layout')
    if (!localStorage.getItem('vspanel-skin')){
      if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
        document.body.classList.add('dark-layout')
        store.commit('appConfig/UPDATE_SKIN', "dark")
      }
    }

    provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 3000,
      transition: 'Vue-Toastification__fade',
    })

    // Set Window Width in store
    store.commit('app/UPDATE_WINDOW_WIDTH', window.innerWidth)
    const { width: windowWidth } = useWindowSize()
    watch(windowWidth, val => {
      store.commit('app/UPDATE_WINDOW_WIDTH', val)
    })

    return {
      skinClasses,
    }
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';

</style>
